export const checkCodeMeli = (code) => {
  // Check if code is valid: must be 10 digits and not all the same digit
  if (!code || code.length !== 10 || !/^\d{10}$/.test(code) || /(\d)\1{9}/.test(code)) {
    return false;
  }

  let sum = 0;
  const chars = code.split("");

  // Calculate weighted sum for the first 9 digits
  for (let i = 0; i < 9; i++) {
    sum += parseInt(chars[i]) * (10 - i);
  }

  const remainder = sum % 11;
  const checkDigit = remainder < 2 ? remainder : 11 - remainder;

  // Compare calculated check digit with the 10th digit
  return parseInt(chars[9]) === checkDigit;
};